import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import Auth from '../Function/Auth';
import { toast, ToastContainer } from "react-toastify";
import axios from 'axios';

function Setting() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [tabelLoading, setTableLoading] = useState(false);
  const [amsterdata, setMasterData] = useState("");
  const [signupBonus, setSignupBonus] = useState(0);
  const [directIncome, setDirectIncome] = useState(0);
  const [businessCount, setBusinessCount] = useState(0)

  const [withdrawStatus, setWithdrawStatus] = useState(0)
  const [withdrawType, setWithdrawType] = useState(0)
  const [minWithdraw, setMinWithdraw] = useState(0)
  const [middelWithdraw, setMiddelWithdraw] = useState(0)
  const [maxWithdraw, setMaxWithdraw] = useState(0)
  const [withdrawHours, setWithdrawHours] = useState(0)
  const [withdFees, setWithdrawFees] = useState(0)

  const [withdrawAddress, setWithdrawAddress] = useState("")
  const [withdrawKeys, setWithdrawKeys] = useState("")





  const handleProfileDataFetched = (data) => {

    console.log('Admin data', data);
    setTableLoading(true)
  };



  useEffect(() => {
    getSettingData();
  }, []);


  const getSettingData = async () => {
    try {
      const response = await axios.post(
        `${baseurl}/settingData`, // Replace with your actual URL
        {}, // POST body is empty for this request
        {
          headers: {
            Authorization: `Bearer ${authToken}`, // Replace with your actual token
            Accept: 'application/json',
          },
        }
      );

      if (response.data.status === true) {
        setTableLoading(true)
        const masterData = response.data;
        setMasterData(masterData.data);
        setSignupBonus(masterData.data.signup_bonus);
        setDirectIncome(masterData.data.direct_income);
        setBusinessCount(masterData.data.business_count);
        setWithdrawStatus(masterData.data.withdraw_status);
        setWithdrawType(masterData.data.withdraw_type);
        setMinWithdraw(masterData.data.min_withdraw);
        setMiddelWithdraw(masterData.data.middel_withdraw);
        setMaxWithdraw(masterData.data.max_withdraw);
        setWithdrawHours(masterData.data.withdraw_hours);
        setWithdrawFees(masterData.data.withdraw_fees_percentage);
        setWithdrawAddress(masterData.data.withdraw_address);
        
      }

      console.log('Setting Data:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching setting data:', error.response?.data || error.message);
    }
  };



  const updateIncome = async () => {
  try {
    const payload = {
      signup_bonus: signupBonus,
      direct_income: directIncome,
      business_count: businessCount,
    };

    const response = await axios.post(
      `${baseurl}/udateIncome`, // Replace with your actual endpoint
      payload,
      {
        headers: {
          Authorization: `Bearer ${authToken}`, // Replace with actual token
          Accept: 'application/json',
        },
      }
    );

    if(response.data.status){
      toast.success(response.data.message);
    }else{
      toast.error(response.data.message);
    }

    console.log('Update success:', response.data);
  } catch (error) {
    console.error('Update failed:', error.response?.data || error.message);
  }
};


const updateWithdraw =  async () =>{

  try {
    const payload = {
      withdraw_status: withdrawStatus,
      withdraw_type: withdrawType,
      min_withdraw: minWithdraw,
      middel_withdraw: middelWithdraw,
      max_withdraw: maxWithdraw,
      withdraw_hours: withdrawHours,
      withdraw_fees_percentage: withdFees,
    };

    const response = await axios.post(
      `${baseurl}/udateWithdraw`, // Replace with your actual endpoint
      payload,
      {
        headers: {
          Authorization: `Bearer ${authToken}`, // Replace with actual token
          Accept: 'application/json',
        },
      }
    );

    if(response.data.status){
      toast.success(response.data.message);
    }else{
      toast.error(response.data.message);
    }

    console.log('Update success:', response.data);
  } catch (error) {
    console.error('Update failed:', error.response?.data || error.message);
  }


}


const updateWallet = async  () => {

   try {
    const payload = {
      withdraw_address: withdrawAddress,
      withdraw_key: withdrawKeys,
    };

    const response = await axios.post(
      `${baseurl}/updateWithdrawAddress`, // Replace with your actual endpoint
      payload,
      {
        headers: {
          Authorization: `Bearer ${authToken}`, // Replace with actual token
          Accept: 'application/json',
        },
      }
    );

    if(response.data.status){
      toast.success(response.data.message);
    }else{
      toast.error(response.data.message);
    }

    console.log('Update success:', response.data);
  } catch (error) {
    console.error('Update failed:', error.response?.data || error.message);
  }

  
}

 






  return (
    <>
      <Header>
        {!authToken && <Auth onProfileDataFetched={handleProfileDataFetched} />}
        <ToastContainer />
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">

            </div>
            {/* End Page Header */}

            <div className="row">
              <div className="card">
                <div className="card-body">
                  <div className="tabs-menu ">
                    {/* Tabs */}
                    <ul className="nav nav-tabs profile navtab-custom panel-tabs">
                      <li className="">
                        <a
                          href="#home"
                          data-bs-toggle="tab"
                          className="active"
                          aria-expanded="true"
                        >
                          {" "}
                          <span className="visible-xs">
                            <i className="las la-user-circle fs-16 me-1" />
                          </span>{" "}
                          <span className="hidden-xs">Income Setting</span>{" "}
                        </a>
                      </li>
                      <li className="">
                        <a href="#gallery" data-bs-toggle="tab" aria-expanded="false">
                          {" "}
                          <span className="visible-xs">
                            <i className="las la-images fs-15 me-1" />
                          </span>
                          <span className="hidden-xs">Withdraw Setting</span>{" "}
                        </a>
                      </li>
                      <li className="">
                        <a href="#friends01" data-bs-toggle="tab" aria-expanded="false">
                          {" "}
                          <span className="visible-xs">
                            <i className="las la-life-ring fs-16 me-1" />
                          </span>
                          <span className="hidden-xs">Wallet Setting</span>{" "}
                        </a>
                      </li>
                      {/* <li className="">
                        <a href="#settings" data-bs-toggle="tab" aria-expanded="false">
                          {" "}
                          <span className="visible-xs">
                            <i className="las la-cog fs-16 me-1" />
                          </span>
                          <span className="hidden-xs">SETTINGS</span>{" "}
                        </a>
                      </li> */}
                    </ul>
                  </div>
                  <div className="tab-content border border-top-0 p-4 br-dark">
                    <div className="tab-pane border-0 p-0 active" id="home">
                      <h4 className="fs-15 text-uppercase mb-3">Income Setting</h4>
                      <div>
                        <div className="mt-5">
                          <div className="row">
                            <div className="col-6"> Signup Bonus ($) </div>
                            <div className="col-6">
                              <input type="text"  value={signupBonus}  onChange={(e)=>setSignupBonus(e.target.value)} className="form-control" />
                            </div>

                            <div className="col-6 mt-3"> Direct Income % </div>
                            <div className="col-6 mt-3">
                              <input type="text"  value={directIncome} onChange={(e)=>setDirectIncome(e.target.value)}  className="form-control" />
                            </div>

                            <div className="col-6 mt-3">Business & Team Count upto Level </div>
                            <div className="col-6 mt-3">
                              <input type="text"  value={businessCount} onChange={(e)=>setBusinessCount(e.target.value)}  className="form-control" />
                            </div>

                            <div className="col-12 mt-5 text-end">
                              <button className="btn btn-success btn-sm " onClick={updateIncome}>Update Setting</button>

                            </div>



                          </div>
                        </div>
                        
                      </div>
                    </div>
                    <div className="tab-pane border-0 p-0" id="gallery">
                       <h4 className="fs-15 text-uppercase mb-3">Withdraw Setting</h4>
                       <hr/>
                      <div>
                        <div className="mt-5">
                          <div className="row">
                            <div className="col-6">Withdraw Status </div>
                            <div className="col-6">
                              <select className="form-control" onChange={(e)=>setWithdrawStatus(e.target.value)}>
                                <option value={withdrawStatus}>{withdrawStatus}</option>
                                  <option value={'enable'}>enable</option>
                                  <option value={'disable'} >disable</option>
                              </select>
                            </div>


                            <div className="col-6 mt-3">Withdraw Type </div>
                            <div className="col-6 mt-3">
                              <select className="form-control" onChange={(e)=>setWithdrawType(e.target.value)}>
                                 <option value={withdrawType}>{withdrawType}</option>
                                  <option value={'full_auto'}>full_auto</option>
                                  <option value={'semi_auto'} >semi_auto</option>
                                  <option value={'manual'} >manual</option>
                              </select>
                            </div>

                            <div className="col-6 mt-3">Minimum Withdraw ($) </div>
                            <div className="col-6 mt-3">
                              <input type="text"  value={minWithdraw} onChange={(e)=>setMinWithdraw(e.target.value)}  className="form-control" />
                            </div>

                            <div className="col-6 mt-3">Medium Withdraw ($) </div>
                            <div className="col-6 mt-3">
                              <input type="text"  value={middelWithdraw} onChange={(e)=>setMiddelWithdraw(e.target.value)}  className="form-control" />
                            </div>

                            <div className="col-6 mt-3">Maximaum Withdraw ($) </div>
                            <div className="col-6 mt-3">
                              <input type="text"  value={maxWithdraw} onChange={(e)=>setMaxWithdraw(e.target.value)}  className="form-control" />
                            </div>

                            <div className="col-6 mt-3">Maximaum In Hours </div>
                            <div className="col-6 mt-3">
                              <input type="text"  value={withdrawHours} onChange={(e)=>setWithdrawHours(e.target.value)}  className="form-control" />
                            </div>

                            <div className="col-6 mt-3">Withdraw Fees % </div>
                            <div className="col-6 mt-3">
                              <input type="text"  value={withdFees} onChange={(e)=>setWithdrawFees(e.target.value)}  className="form-control" />
                            </div>

                            <div className="col-12 mt-5 text-end">
                              <button className="btn btn-success btn-sm " onClick={updateWithdraw}>Update Withdraw</button>

                            </div>



                          </div>
                        </div>
                        
                      </div>
                    </div>
                    <div className="tab-pane border-0 p-0" id="friends01" role="tabpanel">
                      <h4 className="fs-15 text-uppercase mb-3">Wallet Setting</h4>
                      <div>
                        <div className="mt-5">
                          <div className="row">
                            <div className="col-6">Withdraw Address </div>
                            <div className="col-6">
                              <input type="text"  value={withdrawAddress}  onChange={(e)=>setWithdrawAddress(e.target.value)} className="form-control" />
                            </div>

                            <div className="col-6 mt-3"> Withdraw Security Key </div>
                            <div className="col-6 mt-3">
                              <input type="text"  value={withdrawKeys} onChange={(e)=>setWithdrawKeys(e.target.value)}  className="form-control" />
                            </div>

                            

                            <div className="col-12 mt-5 text-end">
                              <button className="btn btn-success btn-sm " onClick={updateWallet}>Update Setting</button>

                            </div>



                          </div>
                        </div>
                        
                      </div>
                    </div>
                    {/* <div className="tab-pane border-0 p-0" id="settings">
                      <form>
                        <div className="form-group mb-3">
                          <label className="form-label" htmlFor="FullName">
                            Full Name
                          </label>
                          <input
                            type="text"
                            defaultValue="John Doe"
                            id="FullName"
                            className="form-control"
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label className="form-label" htmlFor="Email">
                            Email
                          </label>
                          <input
                            type="email"
                            defaultValue="first.last@example.com"
                            id="Email"
                            className="form-control"
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label className="form-label" htmlFor="Username">
                            Username
                          </label>
                          <input
                            type="text"
                            defaultValue="john"
                            id="Username"
                            className="form-control"
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label className="form-label" htmlFor="Password">
                            Password
                          </label>
                          <input
                            type="password"
                            placeholder="6 - 15 Characters"
                            id="Password"
                            className="form-control"
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label className="form-label" htmlFor="RePassword">
                            Re-Password
                          </label>
                          <input
                            type="password"
                            placeholder="6 - 15 Characters"
                            id="RePassword"
                            className="form-control"
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label className="form-label" htmlFor="AboutMe">
                            About Me
                          </label>
                          <textarea
                            id="AboutMe"
                            className="form-control"
                            defaultValue={
                              "Loren gypsum dolor sit mate, consecrate disciplining lit, tied diam nonunion nib modernism tincidunt it Loretta dolor manga Amalia erst volute. Ur wise denim ad minim venial, quid nostrum exercise ration perambulator suspicious cortisol nil it applique ex ea commodore consequent."
                            }
                          />
                        </div>
                        <button
                          className="btn btn-primary waves-effect waves-light w-md"
                          type="submit"
                        >
                          Save
                        </button>
                      </form>
                    </div> */}
                  </div>
                </div>
              </div>

            </div>


          </div>
        </div>
      </Header>

      <Footer />

    </>
  )
}

export default Setting